<template>
  <div
    class="breaking-news"
    v-if="listIsNotEmpty"
    v-on:mouseenter="pauseAnimation"
    v-on:mouseleave="resumeAnimation"
  >
    <div class="breaking-news__wrapper">
      <div class="breaking-news__title">
        <p>{{$t('dashboard.last-five-alarms')}}</p>
      </div>
      <alarm-breaking-news-item
        v-for="breakingNews in listBeingDisplayed"
        :id="breakingNews.id"
        :items="breakingNews.items"
        :pause="pause"
        :key="breakingNews.id"
        @next-item="onNextItem"
        @finished-item="onFinishedItem"
      />
    </div>
  </div>
</template>

<script>
import globalEventBus from '@/services/globalEventBus';
import { getUniqueId } from '@/services/createId';
import AlarmBreakingNewsItem from '@/domain/components/generalPanel/dashboard/breakingNews/AlarmBreakingNewsItem';
import dashboardService from '@/domain/services/generalPanel/dashboard';
import dashboardEvent from '@/domain/events/dashboard';
import { AlarmStatusType } from 'sigma-mappings';

const DEFAULT_NUMBER_BREAKING_NEWS_ITEMS = 5;

export default {
  components: {
    AlarmBreakingNewsItem,
  },
  data: () => ({
    listBeingDisplayed: [],
    nextItem: {},
    pause: false,
  }),
  computed: {
    listIsNotEmpty() {
      return (this.listBeingDisplayed || []).length !== 0;
    },
  },
  created() {
    this.getNextItem(true);
    this.initListeners();
  },
  beforeDestroy() {
    globalEventBus.off(dashboardEvent.autoRefreshData, this.getNextItem, this);
    document.removeEventListener('visibilitychange', this.changeVisibility);
  },
  methods: {
    refreshData() {
      this.getNextItem(true);
    },
    changeVisibility() {
      this.pause = document.hidden;
    },
    pauseAnimation() {
      this.pause = true;
    },
    resumeAnimation() {
      this.pause = false;
    },
    initListeners() {
      globalEventBus.on(dashboardEvent.autoRefreshData, this.getNextItem, this);
      document.addEventListener('visibilitychange', this.changeVisibility);
    },
    getNextItem(setOnList = false) {
      dashboardService.getAlarmsList({
        pageSize: DEFAULT_NUMBER_BREAKING_NEWS_ITEMS,
        status: [AlarmStatusType.ACTED_ALARM],
      }).then((response) => {
          this.nextItem = response.data;

          if (setOnList) {
            this.onNextItem();
          }
        });
    },
    onNextItem() {
      this.listBeingDisplayed.length = 0;
      if ((this.nextItem || []).length > 0) {
        this.listBeingDisplayed.push({
          id: getUniqueId(),
          items: this.nextItem,
        });
      }
    },
    onFinishedItem(id) {
      this.listBeingDisplayed = this.listBeingDisplayed.filter(item => item.id !== id);
    },
  },
};
</script>

<style scoped lang="sass">
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.breaking-news
  height: 2.86rem
  &__wrapper
    background-color: var(--color-extend-gray)
    width: 100%
    height: 2.86rem
    position: fixed
    overflow: hidden
    z-index: 1000
    +media-max-sm()
      display: none

  &__title
    width: auto
    padding-left: 0.7rem
    background-color: var(--color-extend-gray)
    position: absolute
    text-align: center
    height: 100%
    z-index: 10
    display: flex
    align-items: center
    text-transform: uppercase
    & p
      border-right: 2px solid #ccc
      border-radius: 2px
      padding-right: 0.7rem
      margin-bottom: 0
      color: $color-black-60-no-opacity
</style>
